import { Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor, NgClass } from '@angular/common';

import { OrderBy, OrderByDirection, UNDERSCORE } from '../../../shared/utils/constant';
import { EcallDatacenter, Ecalls, FieldOfEcallDatacenter } from '../../models/ecall-off-model';
import { ECallOffService } from '../../services/ecall-off.service';
import { NumberPipe } from '../../../shared/pipes/number.pipe';
import { DatePipe } from '../../../shared/pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

const SORT_WAY = OrderByDirection.DESC;
const SORT_BY = 'callOffCreationTimestamp';
const LIMIT = 6;
const INDEX = 0;

const ECALL_FIELDS: FieldOfEcallDatacenter[] = [
	'customerCallOffReference',
	'supplierCallOffNumber',
	'supplierCallOffItemNumberConcat',
	'callOffCreationTimestamp',
	'callOffType',
	'batchReferenceConcat',
	'millConcat'
];

@Component({
	selector: 'copo-last-call-off-demand-widget',
	templateUrl: './last-call-off-demand-widget.component.html',
	styleUrl: './last-call-off-demand-widget.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TranslateModule,
		NgFor,
		MatIconModule,

		MatButtonModule,

		MatMenuModule,
		NgClass,
		RouterLink,
		LoadingSpinnerComponent,
		DatePipe,
		NumberPipe
	]
})
export class LastCallOffWidgetComponent implements OnInit {
	@HostBinding('class.passthrough') readonly passthrough = true;

	readonly UNDERSCORE = UNDERSCORE;

	isLoading = true;
	filters = '';
	ecallData?: EcallDatacenter[];
	constructor(
		private readonly eCallOffService: ECallOffService
	) {
		// nothing
	}

	ngOnInit(): void {
		this.getEcalls();
	}

	getEcalls() {
		this.eCallOffService.getEcallsFollowUp(
			ECALL_FIELDS,
			this.filters,
			INDEX,
			LIMIT,
			new OrderBy(SORT_BY, SORT_WAY),
			false,
			true
		).then(async result => {
			await this.eCallOffService.updateEcallDatacenterData(result.results);
			this.ecallData = result.results;
			this.isLoading = false;
		}).catch((error: unknown) => {
			console.error('Error when getting ecalls', error);
			this.isLoading = false;
		});
	}

	icon(ecall: Ecalls | EcallDatacenter) {
		return this.eCallOffService.getIcon(ecall);
	}
}
